'use client'

import { CollectionListingNoFilter } from '@/app/[locale]/collection/_components/collection-listing-no-filter'
import { Tabs } from '@/components/ui/tabs'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useCareShareTabsContext } from '../hooks/care-share-tabs-context'
import { CareAndShareContainer } from './container'

export const CareShareOtherProducts = () => {
  const t = useTranslations()

  const { activeTab, handleTabChange } = useCareShareTabsContext()
  const searchParams = useSearchParams()
  const category = searchParams.get('category')

  // nếu có params thì scroll đến tab
  useEffect(() => {
    if (activeTab && category) {
      const tab = document.getElementById(`tab-${activeTab}`)
      if (tab) {
        // Use timeout to make sure tab is rendered before scrolling
        setTimeout(() => {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }, 100)
      }
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  return (
    <CareAndShareContainer id='care-share-other-products' className='pt-2'>
      <h2 className='text-center font-criteria text-2xl font-bold uppercase leading-8 text-neutral-900 lg:text-4xl lg:leading-[44px]'>
        {t.rich('care_and_share_hardcode.other_products.title', {
          br: () => <br className='hidden' />,
        })}
      </h2>

      <div className='no-scrollbar flex w-full items-center overflow-hidden overflow-x-auto md:justify-center'>
        <Tabs
          className='my-4 p-0 md:my-10'
          triggerClassName='text-sm leading-tight font-medium px-4 py-2 pt-2.5 lg:px-6 lg:py-3'
          variant='filter'
          options={[
            {
              value: 'care-and-share',
              label: t('care_and_share_hardcode.other_products.tabs.all'),
            },

            {
              value: 'bst-ngoi-nha-hy-vong',
              label: t(
                'care_and_share_hardcode.other_products.tabs.bst_ngoi_nha_hy_vong'
              ),
            },

            {
              value: 'bst-gom',
              label: t('care_and_share_hardcode.other_products.tabs.bst_gom'),
            },
            {
              value: 'bst-giai-chay-hong',
              label: t(
                'care_and_share_hardcode.other_products.tabs.bst_giai_chay_hong'
              ),
            },
            {
              value: 'tram-phong-tuong-lai',
              label: t(
                'care_and_share_hardcode.other_products.tabs.tram_phong_tuong_lai'
              ),
            },
          ]}
          key={activeTab}
          defaultValue={activeTab}
          onChange={(value) => handleTabChange(value)}
        />
      </div>

      <div id={`tab-${activeTab}`}>
        <CollectionListingNoFilter slug={activeTab} visibility flatten={1} />
      </div>
    </CareAndShareContainer>
  )
}
